export default window._cmsContent['solar/customer-check']